import {UserDTO, UserType, ExUserRegistrationDetails} from 'hemwb-api';
import {userFind} from './actions';

const userTypeMap = {
  [UserType.SUPERUSER]: 'Super User',
  [UserType.INTERNALUSER]: 'Internal User',
  [UserType.EXTERNALUSER]: 'External User',
};

export const userTypes = Object.keys(userTypeMap) as UserType[];
export const getUserTypeName = (userType: UserType) => userTypeMap[userType];

export const fullName = (user: Pick<UserDTO, 'lastName' | 'firstName' | 'id'>) => {
  if (!user) return '';

  const nameParts = [user.lastName, user.firstName].filter((v) => !!v);
  return nameParts.length > 0 ? nameParts.join(', ') : user.id;
};

export const fullNameWestern = (user: Pick<UserDTO, 'lastName' | 'firstName' | 'id'>) => {
  if (!user) return '';

  const nameParts = [user.firstName, user.lastName].filter((v) => !!v);
  return nameParts.length > 0 ? nameParts.join(' ') : user.id;
};

export const userFindValueReturned = (...params: Parameters<typeof userFind>) =>
  userFind(...params).then((response: any) => {
    // API may return the array directly or wrapped in {value: [...]}
    if (Array.isArray(response)) {
      return response as UserDTO[];
    }
    return (response?.value || []) as UserDTO[];
  });

export const externalUserStatusText = (user: ExUserRegistrationDetails) =>
  user
    ? user.status
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : '';

/**
 * Converts a comma-separated name string from "LastName, FirstName" format to "FirstName LastName" format
 * @param nameString - String in "LastName, FirstName" format (e.g., "Narni, Raghuram")
 * @returns String in "FirstName LastName" format (e.g., "Raghuram Narni")
 */
export const convertCommaSeparatedNameToWestern = (nameString: string): string => {
  if (!nameString || typeof nameString !== 'string') return '';

  const parts = nameString
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part);

  if (parts.length === 2) {
    // "LastName, FirstName" → "FirstName LastName"
    return `${parts[1]} ${parts[0]}`;
  }

  // If not in expected format, return as-is
  return nameString;
};
